import { integrationsDebuggerEnabledAtom } from '@/container/integrations/marketplace/providers/useIntegrationsDebugger';
import { Switch } from '@heidi/design-system/switch';
import { TypographyCaption, TypographyP2SemiBold } from '@heidi/design-system/typography';
import { useAtom } from 'jotai';
import { defineMessages, useIntl } from 'react-intl';

import { EditorVersionDevSection } from './editor-version-dev-section';
import { EhrLinksDevSection } from './ehr-links-dev-section';
import { IntegrationAccountDevSection } from './integration-account-dev-section';
import { IntegrationCapabilitiesDevSection } from './integration-capabilities-dev-section';

const messages = defineMessages({
  heading: {
    defaultMessage: 'Marketplace',
    id: 'components.dev.integration.heading',
  },
  debuggerLabel: {
    defaultMessage: 'Marketplace debugger',
    id: 'components.dev.integration.debuggerLabel',
  },
  debuggerDescription: {
    defaultMessage:
      'Shows Marketplace debugging details on supported integration screens.',
    id: 'components.dev.integration.debuggerDescription',
  },
  toggleAriaLabel: {
    defaultMessage: 'Toggle Marketplace debugger',
    id: 'components.dev.integration.toggleAriaLabel',
  },
});

export function IntegrationDevSection() {
  const intl = useIntl();
  const [isDebuggerEnabled, setIsDebuggerEnabled] = useAtom(
    integrationsDebuggerEnabledAtom
  );

  return (
    <>
      <section aria-labelledby="dev-tools-integration-heading">
        <TypographyP2SemiBold id="dev-tools-integration-heading" className="mb-2">
          {intl.formatMessage(messages.heading)}
        </TypographyP2SemiBold>
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0 flex-1 space-y-0.5">
            <TypographyCaption className="text-text-secondary">
              {intl.formatMessage(messages.debuggerLabel)}
            </TypographyCaption>
            <TypographyCaption className="text-text-tertiary">
              {intl.formatMessage(messages.debuggerDescription)}
            </TypographyCaption>
          </div>
          <Switch
            size="sm"
            className="shrink-0"
            checked={isDebuggerEnabled}
            onCheckedChange={setIsDebuggerEnabled}
            aria-label={intl.formatMessage(messages.toggleAriaLabel)}
          />
        </div>
      </section>
      <EditorVersionDevSection />
      <IntegrationCapabilitiesDevSection />
      <EhrLinksDevSection />
      <IntegrationAccountDevSection />
    </>
  );
}
